module.exports = __webpack_public_path__ + "media/bootstrap-icons/tags-e14f26c3.svg";